export default {
    FORM_TYPE_LOGIN: 'FORM_TYPE_LOGIN',
    FORM_TYPE_RESET: 'FORM_TYPE_RESET',
    FORM_TYPE_SIGN_UP: 'FORM_TYPE_SIGN_UP'
}

export const PASSWORD_LIMITS = {
    MAX_LENGTH: 30,
    MIN_LENGTH: 6
}